(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snuggs-sticky-atc"]) return;
  try {
    
(function () {
  function init() {
    var bar = document.getElementById('SnuggsStickyAtc');
    if (!bar || bar.dataset.snuggsReady) return;

    var realBtn = document.querySelector('product-form .product-form__submit');
    var anchor = document.querySelector('product-form');
    if (!realBtn || !anchor) {
      bar.remove();
      return;
    }
    bar.dataset.snuggsReady = '1';

    var proxy = bar.querySelector('[data-snuggs-add]');
    var label = bar.querySelector('[data-snuggs-label]');
    var priceOut = bar.querySelector('[data-snuggs-price]');
    var container = document.querySelector('.product__info-container') || anchor;

    var maxNudges = parseInt(bar.getAttribute('data-nudge-max'), 10) || 0;
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var count = 0;
    var timer = null;
    var stopped = false;
    var syncing = false;

    function text(node) {
      return node ? node.textContent.trim() : '';
    }

    function syncPrice() {
      if (!priceOut) return;
      var mp = container.querySelector('.price');
      if (!mp) return;

      var now =
        text(mp.querySelector('.price__sale .price-item--sale')) ||
        text(mp.querySelector('.price__regular .price-item--regular')) ||
        text(mp.querySelector('.price-item--regular'));
      var was = text(mp.querySelector('.price__sale .price-item--regular'));

      if (!now) return;

      priceOut.textContent = '';
      if (was && was !== now) {
        var s = document.createElement('s');
        s.textContent = was;
        priceOut.appendChild(s);
        priceOut.appendChild(document.createTextNode(' '));
      }
      var strong = document.createElement('strong');
      strong.textContent = now;
      priceOut.appendChild(strong);
    }

    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        var span = realBtn.querySelector('span');
        if (span && label) label.textContent = span.textContent.trim();
        proxy.disabled = realBtn.disabled;
        syncPrice();
      } finally {
        syncing = false;
      }
    }

    function stopNudge() {
      stopped = true;
      clearTimeout(timer);
      proxy.classList.remove('is-nudging');
    }

    function scheduleNudge() {
      if (reduce || stopped || count >= maxNudges) return;
      clearTimeout(timer);
      timer = setTimeout(
        function () {
          if (stopped || bar.hasAttribute('hidden') || proxy.disabled) return;
          proxy.classList.add('is-nudging');
          count++;
          setTimeout(function () {
            proxy.classList.remove('is-nudging');
            scheduleNudge();
          }, 700);
        },
        count === 0 ? 1200 : 15000
      );
    }

    proxy.addEventListener('click', function () {
      stopNudge();
      realBtn.click();
    });
    bar.addEventListener('pointerdown', stopNudge, { once: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.setAttribute('hidden', '');
              document.body.classList.remove('snuggs-sticky-on');
              clearTimeout(timer);
            } else {
              sync();
              bar.removeAttribute('hidden');
              document.body.classList.add('snuggs-sticky-on');
              scheduleNudge();
            }
          });
        },
        { rootMargin: '0px 0px -60px 0px' }
      ).observe(anchor);
    }

    new MutationObserver(sync).observe(container, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        bar.classList.toggle('is-behind', drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
